import { c as _c } from "react/compiler-runtime";
import { PopoverFullPropertiesType } from "@website/ui/popover-full/popover-full.types";
import { MouseEvent, useEffect, useRef, useState } from "react";
export const usePopoverFull = properties => {
  const $ = _c(16);
  const rootReference = useRef(null);
  const {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby,
    id,
    animate,
    open,
    onClose
  } = properties;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [animateOpen, setAnimateOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== animate || $[1] !== onClose || $[2] !== open) {
    t0 = () => {
      const checkIfClickedOutside = t2 => {
        const {
          target
        } = t2;
        if (open && rootReference.current && !rootReference.current.contains(target as Node)) {
          onClose && onClose();
        }
      };
      if (document) {
        if (open) {
          document.addEventListener("click", checkIfClickedOutside);
          setPopoverOpen(true);
          setTimeout(() => {
            setAnimateOpen(true);
          }, 0);
        } else {
          document.removeEventListener("click", checkIfClickedOutside);
          setAnimateOpen(false);
          setTimeout(() => {
            setPopoverOpen(false);
          }, animate === "normal" ? 0 : 75);
        }
      }
      return () => {
        if (document) {
          document.removeEventListener("click", checkIfClickedOutside);
        }
      };
    };
    t1 = [animate, onClose, open];
    $[0] = animate;
    $[1] = onClose;
    $[2] = open;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const stopPropagationOnModal = _temp;
  let t2;
  if ($[5] !== ariaDescribedby || $[6] !== ariaLabelledby || $[7] !== id) {
    t2 = {
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      ref: rootReference,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[5] = ariaDescribedby;
    $[6] = ariaLabelledby;
    $[7] = id;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = animate === "normal" ? 0 : 75;
  let t4;
  if ($[9] !== t3) {
    t4 = {
      timeout: t3
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== animateOpen || $[12] !== popoverOpen || $[13] !== t2 || $[14] !== t4) {
    t5 = {
      rootProps: t2,
      transitionProps: t4,
      popoverOpen,
      animateOpen
    };
    $[11] = animateOpen;
    $[12] = popoverOpen;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp(event) {
  event.stopPropagation();
}